"use client";

import type { ScreenCapture } from "@zetalabs/core";
import { useEffect, useRef, useState } from "react";
import { Button } from "../button";
import { HStack, VStack } from "../layout/stack";
import { cn } from "../lib/utils";
import { ToolAvatar } from "./tool/tool-avatar";

interface LiveViewProps {
	data: ScreenCapture[];
	title?: string;
	isLive?: boolean;
}

export function LiveView({
	data,
	title,
}: LiveViewProps): React.ReactElement | null {
	const captionsRef = useRef<HTMLDivElement>(null);
	const [currentScreenIndex, setCurrentScreenIndex] = useState(0);

	useEffect(() => {
		if (data.length > 0) {
			setCurrentScreenIndex(data.length - 1);
		}
	}, [data.length]);

	const currentScreen = data[currentScreenIndex];

	useEffect(() => {
		if (captionsRef.current) {
			const element = captionsRef.current;
			element.scrollTop = element.scrollHeight;
		}
	}, []);

	return (
		<HStack className="h-full w-full">
			<HStack className="relative h-full w-full items-center justify-center bg-black text-white">
				<HStack className="absolute top-0 right-0 left-0 items-center justify-between bg-gradient-to-b from-black to-transparent p-lg text-md">
					<HStack className="items-center gap-md">
						<div className="rounded-full bg-message-webagent-background">
							<ToolAvatar icon="ai" />
						</div>
						{title}
					</HStack>
				</HStack>
				<img
					alt={currentScreen.caption}
					className="h-full w-auto"
					src={currentScreen.uri}
				/>
			</HStack>
			<VStack
				className="relative my-auto max-h-full w-[312px] flex-shrink-0 overflow-y-auto p-lg"
				ref={captionsRef}
			>
				{data.map((screen, idx) => {
					return (
						<Button
							className={cn(
								currentScreenIndex === idx ? "" : "opacity-50",
								"hover:opacity-100",
								"text-left text-text-body",
							)}
							intent="ghost"
							key={screen.id}
							onClick={() => {
								setCurrentScreenIndex(idx);
							}}
						>
							{screen.caption}
						</Button>
					);
				})}
			</VStack>
		</HStack>
	);
}
